import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/go.png'
import _imports_1 from '@/assets/img/court.png'
import _imports_2 from '@/assets/img/west-city1.png'
import _imports_3 from '@/assets/img/west-city2.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7609cf65")

_pushScopeId("data-v-7609cf65")
const _hoisted_1 = { class: "confirmation" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 地址确认书 ")
const _hoisted_4 = { class: "right-btn" }
const _hoisted_5 = { class: "header none-pc" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " 地址确认书 ", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "header none-pc" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, " 地址确认书 ", -1)
const _hoisted_10 = { class: "courtName" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "courtimg" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "当事人送达地址确认书", -1)
const _hoisted_13 = { class: "content" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "item-tab-caveat" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "title",
    style: {"margin":"10px 0"}
  }, "告知事项："),
  /*#__PURE__*/_createVNode("div", { class: "note" }, [
    /*#__PURE__*/_createVNode("p", null, " 根据相关法律规定和司法解释（相关内容见本确认书背面），告知如下： "),
    /*#__PURE__*/_createVNode("p", null, " 一、受送达人应当向人民法院提供准确的送达地址，并填写送达地址确认书。当事人委托诉讼代理人的，诉讼代理人确认的送达地址视为当事人的送达地址。 "),
    /*#__PURE__*/_createVNode("p", null, " 二、受送达人可自愿选择是否同意适用电子邮箱、短信、人民法院在线服务等电子送达方式。 "),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 三、当事人在送达地址确认书中确认的送达地址适用于 "),
      /*#__PURE__*/_createVNode("span", null, "一审、二审和执行程序"),
      /*#__PURE__*/_createTextVNode("。当事人变更送达地址的，应及时告知人民法院。当事人未及时告知的，以其确认的地址为送达地址。 ")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 四、因受送达人拒不提供送达地址、提供虚假地址或者提供送达地址不准确、送达地址变更未及时告知人民法院、受送达人拒绝签收，导致诉讼文书未能被受送达人实际接收， "),
      /*#__PURE__*/_createVNode("span", null, " 直接送达的，诉讼文书留在该地址之日为送达之日；邮寄送达的，诉讼文书被退回之日为送达之日。 ")
    ])
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "title" }, "当事人", -1)
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "姓名：(名称)", -1)
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*"),
  /*#__PURE__*/_createVNode("span", null, "证件类型：")
], -1)
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "证件号码:", -1)
const _hoisted_24 = { class: "item" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "手机号码:", -1)
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "所在地区：", -1)
const _hoisted_30 = { style: {"display":"flex"} }
const _hoisted_31 = { class: "item-textarea" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "详细地址:", -1)
const _hoisted_34 = { class: "textareaSty" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "ele-tit" }, "电子送达", -1)
const _hoisted_36 = {
  class: "item",
  style: {"font-weight":"bold"}
}
const _hoisted_37 = /*#__PURE__*/_createVNode("span", null, "是否同意电子送达：", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "ele-tit-con" }, "请选择具体的电子送达方式：", -1)
const _hoisted_40 = { class: "ele-checkbox" }
const _hoisted_41 = { style: {"display":"flex"} }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", null, "电子邮件，邮箱地址为：", -1)
const _hoisted_43 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_44 = { style: {"display":"flex"} }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", null, " 短信，手机号码：", -1)
const _hoisted_46 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", null, "人民法院在线服务平台", -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "title" }, "代理人", -1)
const _hoisted_50 = { class: "item" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "姓名：(名称)", -1)
const _hoisted_53 = { class: "item" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*"),
  /*#__PURE__*/_createVNode("span", null, "证件类型：")
], -1)
const _hoisted_55 = { class: "item" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("span", null, "证件号码:", -1)
const _hoisted_58 = { class: "item" }
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "手机号码:", -1)
const _hoisted_61 = { class: "item" }
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "所在地区：", -1)
const _hoisted_64 = { style: {"display":"flex"} }
const _hoisted_65 = { class: "item-textarea" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "requireds" }, "*", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "详细地址:", -1)
const _hoisted_68 = { class: "textareaSty" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "ele-tit" }, "电子送达", -1)
const _hoisted_70 = {
  class: "item",
  style: {"font-weight":"bold"}
}
const _hoisted_71 = /*#__PURE__*/_createVNode("span", null, "是否同意电子送达：", -1)
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "ele-tit-con" }, "请选择具体的电子送达方式：", -1)
const _hoisted_74 = {
  class: "ele-checkbox",
  style: {"word-wrap":"break-word","width":"100%"}
}
const _hoisted_75 = { style: {"display":"flex"} }
const _hoisted_76 = /*#__PURE__*/_createVNode("div", null, "电子邮件，邮箱地址为：", -1)
const _hoisted_77 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_78 = { style: {"display":"flex"} }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", null, " 短信，手机号码： ", -1)
const _hoisted_80 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_81 = /*#__PURE__*/_createVNode("div", null, "人民法院在线服务平台", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("div", {
  class: "title",
  style: {"width":"300px"}
}, " 对以上送达地址和送达方式的确认 ", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "indent" }, " 我（单位）已经阅读了人民法院送达地址确认书 的告知事项及相关法律规定， 保证上述送达地址准确、有效，并愿意承担相应的法律后果。 ", -1)
const _hoisted_84 = { class: "content" }
const _hoisted_85 = /*#__PURE__*/_createVNode("span", {
  class: "requireds",
  style: {"padding-left":"15px"}
}, "*", -1)
const _hoisted_86 = { class: "item-left" }
const _hoisted_87 = {
  style: {"padding-top":"18px"},
  class: "signs"
}
const _hoisted_88 = { style: {"text-align":"right"} }
const _hoisted_89 = { class: "content" }
const _hoisted_90 = { class: "item-tab" }
const _hoisted_91 = /*#__PURE__*/_createVNode("span", null, "日期：", -1)
const _hoisted_92 = { class: "item" }
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "item-left" }, "备注：", -1)
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div class=\"item-tab-caveat\" data-v-7609cf65><h4 style=\"text-align:center;\" data-v-7609cf65><span data-v-7609cf65>送达地址告知书</span></h4><div class=\"rows rem\" data-v-7609cf65> 根据《中华人民共和国民事诉讼法》《最高人民法院关于适用〈中华人民共和国民事诉讼法〉的解释》等规定，现将送达地址及送达方式有关事项告知如下： </div><div class=\"rows rem\" data-v-7609cf65> 一、送达地址确认书是确保人民法院有效送达的重要条件。送达地址确认书应当包括当事人提供的送达地址、人民法院告知事项、当事人对送达地址的确认、送达地址确认书的适用范围和变更方式等内容。 </div><div class=\"rows rem\" data-v-7609cf65> 二、当事人提供的送达地址应包括邮政编码、详细地址以及受送达人的联系电话等。同意电子送达的，应当确认接收诉讼文书的电子送达地址。当事人委托诉讼代理人的，诉讼代理人确认的送达地址视为当事人的送达地址。 </div><div class=\"rows rem\" data-v-7609cf65> 三、当事人拒绝确认送达地址或以拒绝应诉、拒接电话、避而不见送达人员、搬离原住所等躲避、规避送达，人民法院不能或无法要求其确认送达地址的，可以分别以下列情形处理： </div><div class=\"rows rem\" data-v-7609cf65> （一）当事人在诉讼所涉及的合同、往来函件中对送达地址有明确约定的，以约定的地址为送达地址； </div><div class=\"rows rem\" data-v-7609cf65> （二）没有约定的，以当事人在诉讼中提交的书面材料中载明的自己的地址为送达地址； </div><div class=\"rows rem\" data-v-7609cf65> （三）没有约定、当事人也未提交书面材料或者书面材料中未载明地址，以一年内进行其他诉讼、仲裁案件中提供的地址为送达地址； </div><div class=\"rows rem\" data-v-7609cf65> （四）无以上情形的，以当事人一年内进行民事活动时经常使用的地址为送达地址。 </div><div class=\"rows rem\" data-v-7609cf65> 依上述情形仍不能确认送达地址的，自然人以其户籍登记的住所或在经常居住地登记的住址为送达地址，法人或者其他组织以其工商登记或其他依法登记、备案的住所地为送达地址。 </div><div class=\"rows\" data-v-7609cf65>【电子送达】</div><div class=\"rows rem\" data-v-7609cf65>1.适用前提</div><div class=\"rows rem\" data-v-7609cf65> 受送达人同意的，人民法院可以采用电子送达方式送达诉讼文书。 </div><div class=\"rows rem\" data-v-7609cf65>2.法律效力</div><div class=\"rows rem\" data-v-7609cf65> 以电子送达方式送达诉讼文书的，其送达与人民法院其他方式送达具有同等法律效力。 </div><div class=\"rows rem\" data-v-7609cf65>3.使用说明</div><div class=\"rows rem\" data-v-7609cf65> （1）如受送达人同意以短信送达方式接收诉讼文书，需向本院提供手机号码，该手机号码将用于接收法院以短信形式发送的诉讼文书。 </div><div class=\"rows rem\" data-v-7609cf65> （2）如受送达人同意通过“人民法院在线服务”等接收诉讼文书，需要关注并按要求注册绑定。 </div><div class=\"rows rem\" data-v-7609cf65> （3）如受送达人同意通过电子邮件接收诉讼文书，需提供接收电子邮件的邮箱。 </div></div>", 1)
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { class: "west-court-img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_96 = { class: "btn" }
const _hoisted_97 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"10px"} }, "请联系法院工作人员获取修改指令", -1)
const _hoisted_98 = { class: "dialog-footer" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_100 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_signature = _resolveComponent("signature")
  const _component_HeaderTit = _resolveComponent("HeaderTit")
  const _component_UserType = _resolveComponent("UserType")
  const _component_UserUpload = _resolveComponent("UserUpload")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_link_age = _resolveComponent("link-age")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_signature, {
      "place-holder-str": "请在此区域签名",
      onSignEvent: _ctx.signEvent,
      onSignreturnEvent: _ctx.signreturnEvent
    }, null, 8, ["onSignEvent", "onSignreturnEvent"]), [
      [_vShow, _ctx.signShow]
    ]),
    _withDirectives(_createVNode("div", null, [
      (_ctx.isShow === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_HeaderTit, { show: false }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_UserType, {
              userType: _ctx.caseUserType.value,
              proxyType: _ctx.proxyType.value,
              onNextusertypefun: _ctx.nextUserTypeFun,
              ref: "userType"
            }, null, 8, ["userType", "proxyType", "onNextusertypefun"]),
            _createVNode("div", _hoisted_4, [
              _withDirectives(_createVNode("button", {
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.modifyMessage(...args)))
              }, "修改信息", 512), [
                [_vShow, _ctx.isShow == 1]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", null, [
        _createVNode("div", _hoisted_5, [
          _createVNode("img", {
            src: _imports_0,
            class: "go",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.goBack(1)))
          }),
          _hoisted_6
        ]),
        _createVNode(_component_UserUpload, {
          userType: _ctx.caseUserType,
          proxyType: _ctx.proxyType,
          onUserTypeFun: _ctx.userTypeFun,
          onNextuser: _ctx.nextUser,
          ref: "userUpload"
        }, null, 8, ["userType", "proxyType", "onUserTypeFun", "onNextuser"])
      ], 512), [
        [_vShow, _ctx.isShow === 2]
      ]),
      (_ctx.isShow === 3)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("img", {
                src: _imports_0,
                class: "go",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.goBack(2)))
              }),
              _hoisted_9
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", null, [
                _createVNode("p", null, _toDisplayString(_ctx.courtName), 1),
                _hoisted_12
              ])
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", null, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _hoisted_18,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.ruleForm.userName = $event)),
                      placeholder: "请输入当事人名称"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ruleForm.userName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.ruleForm.userIdentityType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.ruleForm.userIdentityType = $event)),
                      placeholder: "请选择",
                      class: "m-el-input",
                      clearable: ""
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityTypeList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.code,
                            label: item.name,
                            value: item.code
                          }, null, 8, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.ruleForm.userIdentityNumber = $event)),
                      placeholder: "请输入证件号码"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ruleForm.userIdentityNumber,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _hoisted_26,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.ruleForm.userMobilephone = $event)),
                      placeholder: "请输入手机号"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ruleForm.userMobilephone,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_link_age, {
                        style: {"width":"33%"},
                        modelValue: _ctx.ruleForm.province,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.ruleForm.province = $event)),
                        list: _ctx.areaOptions.shengList
                      }, null, 8, ["modelValue", "list"]),
                      _createVNode(_component_link_age, {
                        style: {"width":"33%"},
                        modelValue: _ctx.ruleForm.city,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.ruleForm.city = $event)),
                        list: _ctx.areaOptions.shiList
                      }, null, 8, ["modelValue", "list"]),
                      _createVNode(_component_link_age, {
                        style: {"width":"33%"},
                        modelValue: _ctx.ruleForm.district,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.ruleForm.district = $event)),
                        list: _ctx.areaOptions.quList
                      }, null, 8, ["modelValue", "list"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        style: {"width":"100%","border-radius":"8px"},
                        modelValue: _ctx.ruleForm.userDetailAddress,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.ruleForm.userDetailAddress = $event)),
                        placeholder: "请输入送达详细地址"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_35,
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.ruleForm.userIsElectronic,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.ruleForm.userIsElectronic = $event)),
                      placeholder: "请选择",
                      class: "m-el-input",
                      style: {"width":"100px"}
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.isElectronicList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.code,
                            label: item.name,
                            value: item.code
                          }, null, 8, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (_ctx.ruleForm.userIsElectronic == true)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode("div", _hoisted_40, [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: _ctx.typeOptions.userElectronicType,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (_ctx.typeOptions.userElectronicType = $event))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                label: "2",
                                class: "checkoutbox"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    (
                              _ctx.typeOptions.userElectronicType &&
                              _ctx.typeOptions.userElectronicType.indexOf('2') > -1
                            )
                                      ? (_openBlock(), _createBlock("span", _hoisted_43, "*"))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      placeholder: "请输入邮箱地址",
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.ruleForm.userEmail = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.ruleForm.userEmail]
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_checkbox, {
                                label: "7",
                                class: "checkoutbox"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    (
                              _ctx.typeOptions.userElectronicType &&
                              _ctx.typeOptions.userElectronicType.indexOf('7') > -1
                            )
                                      ? (_openBlock(), _createBlock("span", _hoisted_46, "*"))
                                      : _createCommentVNode("", true),
                                    (
                              _ctx.typeOptions.userElectronicType &&
                              _ctx.typeOptions.userElectronicType.indexOf('7') > -1
                            )
                                      ? _withDirectives((_openBlock(), _createBlock("input", {
                                          key: 1,
                                          type: "text",
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.ruleForm.userElecPhone = $event)),
                                          placeholder: "请输入手机号"
                                        }, null, 512)), [
                                          [_vModelText, _ctx.ruleForm.userElecPhone]
                                        ])
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_checkbox, {
                                label: "8",
                                class: "checkoutbox"
                              }, {
                                default: _withId(() => [
                                  _hoisted_47
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.caseUserType === 2)
                  ? (_openBlock(), _createBlock("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _hoisted_52,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (_ctx.ruleForm.agentName = $event)),
                          placeholder: "请输入代理人名称"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.ruleForm.agentName,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.ruleForm.agentIdentityType,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (_ctx.ruleForm.agentIdentityType = $event)),
                          placeholder: "请选择",
                          class: "m-el-input",
                          clearable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityTypeList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _hoisted_57,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (_ctx.ruleForm.agentIdentityNumber = $event)),
                          placeholder: "请输入证件号码",
                          onChange: _cache[19] || (_cache[19] = (...args) => (_ctx.filter(...args)))
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.ruleForm.agentIdentityNumber,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _hoisted_60,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (_ctx.ruleForm.agentMobilephone = $event)),
                          placeholder: "请输入手机号"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.ruleForm.agentMobilephone,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _hoisted_63,
                        _createVNode("div", _hoisted_64, [
                          _createVNode(_component_link_age, {
                            style: {"width":"33%"},
                            modelValue: _ctx.ruleForm.agentProvince,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (_ctx.ruleForm.agentProvince = $event)),
                            list: _ctx.agentAreaOptions.shengList
                          }, null, 8, ["modelValue", "list"]),
                          _createVNode(_component_link_age, {
                            style: {"width":"33%"},
                            modelValue: _ctx.ruleForm.agentCity,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => (_ctx.ruleForm.agentCity = $event)),
                            list: _ctx.agentAreaOptions.shiList
                          }, null, 8, ["modelValue", "list"]),
                          _createVNode(_component_link_age, {
                            style: {"width":"33%"},
                            modelValue: _ctx.ruleForm.agentDistrict,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (_ctx.ruleForm.agentDistrict = $event)),
                            list: _ctx.agentAreaOptions.quList
                          }, null, 8, ["modelValue", "list"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _hoisted_67,
                        _createVNode("div", _hoisted_68, [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            style: {"width":"100%","border-radius":"8px"},
                            modelValue: _ctx.ruleForm.agentDetailAddress,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (_ctx.ruleForm.agentDetailAddress = $event)),
                            placeholder: "请输入送达详细地址"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_69,
                      _createVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.ruleForm.agentIsElectronic,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (_ctx.ruleForm.agentIsElectronic = $event)),
                          placeholder: "请选择",
                          class: "m-el-input",
                          style: {"width":"100px"}
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.isElectronicList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.code,
                                label: item.name,
                                value: item.code
                              }, null, 8, ["label", "value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (_ctx.ruleForm.agentIsElectronic == true)
                        ? (_openBlock(), _createBlock("div", _hoisted_72, [
                            _hoisted_73,
                            _createVNode("div", _hoisted_74, [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: _ctx.typeOptions.agentElectronicType,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (_ctx.typeOptions.agentElectronicType = $event))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_checkbox, {
                                    label: "2",
                                    class: "checkoutbox"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_75, [
                                        _hoisted_76,
                                        (
                              _ctx.typeOptions.agentElectronicType &&
                              _ctx.typeOptions.agentElectronicType.indexOf('2') > -1
                            )
                                          ? (_openBlock(), _createBlock("span", _hoisted_77, "*"))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          placeholder: "请输入邮箱地址",
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => (_ctx.ruleForm.agentEmail = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.ruleForm.agentEmail]
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_checkbox, {
                                    label: "7",
                                    class: "checkoutbox"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_78, [
                                        _hoisted_79,
                                        (
                              _ctx.typeOptions.agentElectronicType &&
                              _ctx.typeOptions.agentElectronicType.indexOf('7') > -1
                            )
                                          ? (_openBlock(), _createBlock("span", _hoisted_80, "*"))
                                          : _createCommentVNode("", true),
                                        (
                              _ctx.typeOptions.agentElectronicType &&
                              _ctx.typeOptions.agentElectronicType.indexOf('7') > -1
                            )
                                          ? _withDirectives((_openBlock(), _createBlock("input", {
                                              key: 1,
                                              type: "text",
                                              placeholder: "请输入手机号",
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (_ctx.ruleForm.agentElecPhone = $event))
                                            }, null, 512)), [
                                              [_vModelText, _ctx.ruleForm.agentElecPhone]
                                            ])
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_checkbox, {
                                    label: "8",
                                    class: "checkoutbox"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_81
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_82,
                _hoisted_83,
                _createVNode("div", _hoisted_84, [
                  _createVNode("div", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.signs, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: "item-textarea"
                      }, [
                        _hoisted_85,
                        _createVNode("span", _hoisted_86, _toDisplayString(item.text), 1),
                        _createVNode("div", _hoisted_87, [
                          (item.isHavingImg)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: _ctx.signSrc,
                                width: 290,
                                height: 91
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          (!item.isHavingImg && !_ctx.signImgStr)
                            ? (_openBlock(), _createBlock("div", {
                                key: 1,
                                onClick: _cache[29] || (_cache[29] = (...args) => (_ctx.signShowFun(...args))),
                                class: "clickSigns"
                              }, " 点击签名 "))
                            : _createCommentVNode("", true),
                          (!item.isHavingImg && _ctx.signImgStr)
                            ? (_openBlock(), _createBlock("img", {
                                key: 2,
                                src: _ctx.signImgStr,
                                alt: "",
                                width: 290,
                                height: 91
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createVNode("div", _hoisted_88, [
                      _createVNode("button", {
                        class: "clear",
                        onClick: _cache[30] || (_cache[30] = (...args) => (_ctx.signShowFun(...args)))
                      }, "前往签名")
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_89, [
                _createVNode("div", _hoisted_90, [
                  _hoisted_91,
                  _createVNode("span", null, _toDisplayString(_ctx.newData), 1)
                ]),
                _createVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (_ctx.ruleForm.remark = $event)),
                    placeholder: "请输入备注"
                  }, null, 512), [
                    [_vModelText, _ctx.ruleForm.remark]
                  ])
                ]),
                _hoisted_94
              ]),
              _hoisted_95
            ]),
            _createVNode("div", _hoisted_96, [
              _createVNode("button", {
                class: "btnSubmit",
                onClick: _cache[32] || (_cache[32] = (...args) => (_ctx.submit(...args)))
              }, "提交")
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        title: "提示",
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => (_ctx.dialogVisible = $event)),
        width: "80%",
        onClose: _ctx.cancelGetCode
      }, {
        footer: _withId(() => [
          _createVNode("span", _hoisted_98, [
            _createVNode(_component_el_button, {
              size: "mini",
              onClick: _ctx.cancelGetCode
            }, {
              default: _withId(() => [
                _hoisted_99
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              onClick: _ctx.confirmGetCode
            }, {
              default: _withId(() => [
                _hoisted_100
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withId(() => [
          _createVNode("div", null, [
            _hoisted_97,
            _createVNode(_component_el_input, {
              modelValue: _ctx.verifyCode,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (_ctx.verifyCode = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ], 512), [
      [_vShow, !_ctx.signShow]
    ])
  ]))
})